// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment-type-select .v-input__slot {\n  background: inherit !important;\n}\n.theme--light.comment-type-select-item-cont .comment-type-select-item-badge .v-badge__badge {\n  background-color: #eb3223 !important;\n}\n.theme--dark.comment-type-select-item-cont .comment-type-select-item-badge .v-badge__badge {\n  background-color: #eb3223 !important;\n}", ""]);
// Exports
module.exports = exports;
